import primaryButtonActive from '../../../../../common/algorithms/primary-button-active';

const secondary = (params) => primaryButtonActive(params, true);

export default secondary;
